import { type AuditChecklistForm } from '#packages/data-collection/models/audit-checklist-form';

import { type EditAuditFormChecklistData } from './types';

export const fromFormData = (
  formData: EditAuditFormChecklistData,
): AuditChecklistForm => ({
  type: 'checklist',

  isEveryRoomChecked: formData.isEveryRoomChecked ?? false,
  isEveryFormFilled: formData.isEveryFormFilled ?? false,
  hasRooftopPhotos: formData.hasRooftopPhotos ?? false,
  hasBuildingSidePhotos: formData.hasBuildingSidePhotos ?? false,
  hasDoorsAndWindowsPhotos: formData.hasDoorsAndWindowsPhotos ?? false,
  hasBASInterfacePhotos: formData.hasBASInterfacePhotos ?? false,
  hasEnvelopeThermalImages: formData.hasEnvelopeThermalImages ?? false,
});

export const toFormData = (
  data: AuditChecklistForm | undefined,
): EditAuditFormChecklistData => ({
  isEveryRoomChecked: data?.isEveryRoomChecked ?? false,
  isEveryFormFilled: data?.isEveryFormFilled ?? false,
  hasRooftopPhotos: data?.hasRooftopPhotos ?? false,
  hasBuildingSidePhotos: data?.hasBuildingSidePhotos ?? false,
  hasDoorsAndWindowsPhotos: data?.hasDoorsAndWindowsPhotos ?? false,
  hasBASInterfacePhotos: data?.hasBASInterfacePhotos ?? false,
  hasEnvelopeThermalImages: data?.hasEnvelopeThermalImages ?? false,
});
